module.exports = __webpack_public_path__ + "img/42_19.3ac3f6c7.png";